import { useState } from 'react';

import type { Preference } from '../../../domain/preferences';

import { usePreferencesTracking } from './usePreferencesTracking';

export const usePreferences = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInnerModalOpen, setIsInnerModalOpen] = useState(false);
  const [innerModal, setInnerModal] = useState<Preference | undefined>(undefined);

  const { handleTrackOpenPreferences, handleTrackClickOnPreference } = usePreferencesTracking();

  const handleOpenModal = () => {
    handleTrackOpenPreferences();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setIsInnerModalOpen(false);
      setInnerModal(undefined);
    }, 300);
  };

  const handleClickOnPreference = (selectedPreference: Preference) => {
    handleTrackClickOnPreference(selectedPreference);
    setIsInnerModalOpen(true);
    setInnerModal(selectedPreference);
  };

  const handleCloseInnerModal = () => setIsInnerModalOpen(false);

  return {
    isModalOpen,
    handleOpenModal,
    handleCloseModal,
    isInnerModalOpen,
    innerModal,
    handleClickOnPreference,
    handleCloseInnerModal,
  };
};
